import React from "react";
import PropTypes from "prop-types";

import SectionStreamWrapper from "stream/containers/SectionStreamWrapper";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";

import { DEFAULT_CARD_HEIGHT, SECTION } from "config/constants";

export default function TopSectionStream(props) {
  return (
    <SectionStreamWrapper {...props} slug={SECTION.TOP.slug}>
      {({ streamParams }) => {
        return (
          <React.Fragment>
            {/* Spot for Banner Here */}
            <Stream
              {...streamParams}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
              contentComponent={FullStoryCard}
            />
          </React.Fragment>
        );
      }}
    </SectionStreamWrapper>
  );
}
